/* eslint-disable no-param-reassign */
import Sonda from '@bit/gerenciatd.utils.front-sonda';
import {
  moduloSolucionesSolucionesDigitales, moduloClickBox, moduloVentaCruzada,
} from '../../utils/normalizerModules.utils';
import { createSondaContext } from '../../utils/contextUtils';


/**
 * Normaliza los fusiones que vienen desde catálogo a una estructura válida
 * @param {Object[]} solucionesList - lista de los fusiones que viene desde catálogo
 * @returns {Object[]} - lista de fusiones normalizados
 */
export const normalizeHome = (solucionesList) => {
  const context = createSondaContext('empresas');
  const sonda = new Sonda({
    processName: 'normalizeProductsOfFusion',
    context,
    filePath: 'sagas/normalizers/fusion',
  });
  if (!solucionesList) {
    sonda.severalMessage({ info: 'solucionesList no exist' });
    return null;
  }
  let productsToArray = [];

  if (!Array.isArray(solucionesList)) {
    solucionesList = [solucionesList];
  }

  try {
    // Aqui lo que hacemos es recorrer la lista de modulos, y pasarlos por sus normalizadores
    productsToArray = solucionesList.reduce((arr, currentProduct) => {
      Object.values(currentProduct.data.fields).map((item) => {
        switch (item.name) {
          case 'MODULO_SOLUCIONES_SOLUCIONES_DIGITALES':
            item.fields = moduloSolucionesSolucionesDigitales(item.fields);
            break;
          case 'MODULO_BANNER_INTERNO':
            item.fields = moduloClickBox(item.fields);
            break;
          case 'MODULO_VENTA_CRUZADA_OFERTAS':
            item.fields = moduloVentaCruzada(item.fields);
            break;
          default:
            return null;
        }
        return item;
      });

      arr = [...arr, currentProduct];
      return arr;
    }, []);
    console.log(productsToArray);
    return productsToArray;
  } catch (error) {
    console.log({ error });
    sonda.severalMessage({ error });
    return null;
  }
};
